/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable import/no-extraneous-dependencies */
/* istanbul ignore file */
import { HttpErrorResponse } from '@angular/common/http';
import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from '@ngrx/store';
import {
  BankHoliday,
  BurnToken,
  BuyerAccountInformation,
  CheckoutResolversActions,
  InvoiceSavedPaymentAccountResponse,
  PaymentAccount,
  PaymentAuthorizationChannel,
  PaymentCompletedResponse,
  PaymentExecutionV1Response,
  PaymentInformationServiceErrorV1Response,
  PaymentLinkServiceErrorResponseV1,
  PaymentPreviewErrorPayload,
  PaymentPreviewV1Response,
  PaymentStatus,
  PayOtherAmountV1Response,
  RetrieveAuthorizationVerbiageResponseV1,
  roundTo2Decimals,
  SelectedPaymentAccount,
  SerializableMap,
  TransactionAuthorizationResult,
  setPadVerifiedStatusOnBankAccounts,
  PadAgreementFormSubmitEvent,
  updatePadVerifiedStatus,
  RedirectStateOneTimePaymentAccount,
  TwikeyExitStatus,
  getAccountDisplayName,
} from '@arc/unified-payments-frontend/shared-payment';
import { SessionActions } from '../../session-store/actions';
import {
  BtPayPaymentAccountsActions,
  BtPayPaymentInformationActions,
  PayActions,
  PoaBtPayReviewPaymentActions,
  PoaBtPaySelectPaymentMethodActions,
  PoiBtPayReviewPaymentActions,
  PoiBtPaySelectPaymentMethodActions,
} from '../actions';

import { PoiIntlSepaResultPaymentComponentActions } from '../../component-actions/poi/intl/sepa-result-payment';
import { PoiIntSelectPaymentTypeSessionActions } from '../../component-actions/poi/intl/select-payment-type';
import {
  HostedPaymentsReviewPaymentAuthorizationVerbiageActions,
  HostedPaymentsReviewPaymentComponentActions,
  HostedPaymentsReviewPaymentComponentPaymentActions,
  HostedPaymentsSelectPaymentMethodActions,
  HostedPaymentsSelectPaymentMethodAuthorizationVerbiageActions,
  HostedPaymentsSelectPaymentMethodPadAgreementActions,
  HostedPaymentsSelectPaymentMethodPaymentAccountsActions,
  PoaReviewPaymentComponentActions,
  PoaSelectPaymentMethodComponentActions,
  PoaSelectPaymentMethodPadAgreementActions,
  PoaSelectPaymentMethodPaymentAccountActions,
  PoiPadResultComponentPadActions,
  PoiPadResultComponentSessionActions,
  PoiReviewPaymentComponentActions,
  PoiSelectPaymentMethodComponentActions,
  PoiSelectPaymentMethodPadAgreementActions,
  PoaPadResultComponentSessionActions,
  PoaPadResultComponentPadActions,
  HostedPaymentsPadResultComponentPadActions,
  PoiSelectPaymentMethodPaymentAccountActions,
  HostedPaymentsPadResultComponentSessionActions,
  PoaPadResultComponentPayInfoActions,
  PoiPadResultComponentActions,
  HostedPaymentsPadResultComponentActions,
  PoaPadResultComponentActions,
  PoiIntlStripeResultPaymentComponentActions,
  PoiStripeResultIntlSessionActions,
  PoiStripeResultIntlPaymentPreviewActions,
  PoiStripeResultIntlComponentActions,
  PoiMakePaymentComponentActions,
  PoiIntlMakePaymentComponentActions,
  PoiPaymentReceiptComponentActions,
  PoaPaymentReceiptComponentActions,
  PoiIntlPaymentReceiptComponentActions,
  PoiIntlMakePaymentPaymentInformationApiActions,
  PoaPaymentDetailsComponentActions,
  MakePaymentPaymentLinksApiActions,
  PoaPaymentDetailsPaymentLinksApiActions,
  PoiIntlMakePaymentPaymentLinksApiActions,
  CheckoutHeaderComponentActions,
} from '../../component-actions';

const SIGN_IN_ATTEMPTS_EXCEEDED_CODE = 'SIGN_IN_ATTEMPTS_EXCEEDED';

/**
 * pay-payment-link-service returns SIGN_IN_ATTEMPTS_EXCEEDED (HTTP 429) once a session
 * has hit the server-enforced sign-in verification attempt limit. The wire shape is
 * PascalCase — see PaymentLinkServiceErrorResponseV1.
 */
function isSignInAttemptsExceededError(error: HttpErrorResponse): boolean {
  const body = error?.error as PaymentLinkServiceErrorResponseV1;
  return (
    body?.Errors?.some((e) => e.Code === SIGN_IN_ATTEMPTS_EXCEEDED_CODE) ??
    false
  );
}

export interface MasterConfirmationNumber {
  masterConfirmationNumber?: string;
}

export interface PaymentStoreState {
  authorizePayment: PaymentExecutionV1Response;
  bankAuthVerbiage: RetrieveAuthorizationVerbiageResponseV1;
  bankHolidays: BankHoliday[];
  paymentCompletedResponse: PaymentCompletedResponse;
  paymentCutoffTime: Date;
  paymentPreview: PaymentPreviewV1Response;
  payOtherAmount: PayOtherAmountV1Response;
  paymentStatus: InvoiceSavedPaymentAccountResponse;
  surchargeError: PaymentPreviewErrorPayload;
  surchargeAuthVerbiage: RetrieveAuthorizationVerbiageResponseV1;
  selectedPaymentAccount: SelectedPaymentAccount;
  paymentDate: Date;
  emailRecipients: string[];
  transactionAuthorizationResults: SerializableMap<TransactionAuthorizationResult>;
  isAutopayEnabled: boolean;
  paymentAccounts: PaymentAccount[];
  paymentAuthorizing: boolean;
  paymentAuthorizationPending: boolean;
  paymentStatusCheckTimedOut: boolean;
  paymentStatusCheckCount: number;
  buyerAccounts: BuyerAccountInformation[];
  showAchPaymentDateWarning: boolean;
  achPaymentDateWarningVerbiage: string;
  cardOverrideData: string[];
  paymentAuthorizationChannel: PaymentAuthorizationChannel;
  captchaToken: string | null;
  padAgreementFormSubmitEvent: PadAgreementFormSubmitEvent;
  redirectOtpPaymentAccounts: RedirectStateOneTimePaymentAccount[];
  redirectSelectedPaymentAccountBurn?: string;
  twikeyExitStatus?: TwikeyExitStatus;
  stripeResultStatus?: string;
  isAllPayablesPaidInFull: boolean;
  disablePaymentDate: boolean;
  signInBannerDismissed?: boolean;
  signInEmailToken?: string;
  signInEmailSentBannerVisible?: boolean;
  signInEmailErrorOccurred?: boolean;
  signInUsername?: string | null;
  issuePlatformJwtError?: boolean;
  signInAttemptsExceeded?: boolean;
  unenrolledAutopayAccounts?: string[];
}

export const initialState: PaymentStoreState = {
  // State
  bankHolidays: null,
  transactionAuthorizationResults: {},
  authorizePayment: null,
  bankAuthVerbiage: null,
  paymentCompletedResponse: null,
  paymentCutoffTime: null,
  paymentPreview: null,
  payOtherAmount: null,
  paymentStatus: null,
  surchargeError: null,
  surchargeAuthVerbiage: null,
  selectedPaymentAccount: null,
  paymentDate: null,
  paymentAccounts: null,
  emailRecipients: [],
  isAutopayEnabled: null,
  paymentAuthorizationPending: false,
  paymentAuthorizing: false,
  paymentStatusCheckTimedOut: false,
  paymentStatusCheckCount: 0,
  buyerAccounts: null,
  showAchPaymentDateWarning: false,
  achPaymentDateWarningVerbiage: null,
  cardOverrideData: [],
  paymentAuthorizationChannel: null,
  captchaToken: null,
  padAgreementFormSubmitEvent: null,
  redirectOtpPaymentAccounts: null,
  redirectSelectedPaymentAccountBurn: null,
  twikeyExitStatus: null,
  stripeResultStatus: null,
  isAllPayablesPaidInFull: false,
  disablePaymentDate: false,
  signInBannerDismissed: false,
  signInEmailToken: null,
  signInEmailSentBannerVisible: false,
  signInEmailErrorOccurred: false,
  signInUsername: null,
  issuePlatformJwtError: false,
  signInAttemptsExceeded: false,
  unenrolledAutopayAccounts: null,
};

export const btPayReducers = createReducer(
  initialState,
  on(PayActions.AuthorizePaymentCompleteAction, (state, action) => {
    return {
      ...state,
      authorizePayment: action.payload,
    };
  }),
  on(
    PayActions.RetrieveBankAuthorizationVerbiageCompleteAction,
    PoiBtPayReviewPaymentActions.bankAuthorizationVerbiageUpdated,
    PoaBtPayReviewPaymentActions.bankAuthorizationVerbiageUpdated,
    HostedPaymentsReviewPaymentAuthorizationVerbiageActions.bankAuthorizationVerbiageRetrieved,
    (state, action) => {
      return {
        ...state,
        bankAuthVerbiage: action.payload,
      };
    },
  ),
  on(PayActions.ClearAuthorizationVerbiageAction, (state) => {
    return {
      ...state,
      bankAuthVerbiage: initialState.bankAuthVerbiage,
    };
  }),
  on(PayActions.ClearAuthorizePaymentAction, (state) => {
    return {
      ...state,
      authorizePayment: initialState.authorizePayment,
    };
  }),
  on(PayActions.ClearPaymentStatusAction, (state) => {
    return {
      ...state,
      paymentStatus: initialState.paymentStatus,
    };
  }),
  on(PayActions.GetBankHolidaysSuccessAction, (state, action) => {
    return {
      ...state,
      bankHolidays: action.bankHolidays,
    };
  }),
  on(
    BtPayPaymentInformationActions.GetSurchargeAmountSuccessAction,
    (state, action) => {
      return {
        ...state,
        surchargeError: null,
        paymentPreview: action.payload,
      };
    },
  ),
  on(
    BtPayPaymentInformationActions.ClearSurchargeAmountAction,
    BtPayPaymentInformationActions.GetSurchargeAmountAction,
    (state) => {
      if (state.paymentPreview == null) {
        return {
          ...state,
        };
      }

      return {
        ...state,
        paymentPreview: {
          ...state.paymentPreview,
          payments: state.paymentPreview?.payments.map((p) => {
            return {
              ...p,
              payment: {
                ...p.payment,
                totalAmount: roundTo2Decimals(
                  p.payment.totalAmount - p.payment.totalSurcharge,
                ),
                totalSurcharge: 0,
                payables: p.payment.payables.map((payable) => {
                  return {
                    ...payable,
                    surcharge: 0,
                  };
                }),
              },
            };
          }),
        },
      };
    },
  ),
  on(
    BtPayPaymentInformationActions.GetSurchargeAmountErrorAction,
    (state, action) => {
      return {
        ...state,
        surchargeError: {
          isSelectedCardRestrictedByType:
            action.payload.isSelectedCardRestrictedByType,
          isSelectedCardRestrictedByZipCode:
            action.payload.isSelectedCardRestrictedByZipCode,
          error: action.payload.error as string,
        },
      };
    },
  ),
  on(
    BtPayPaymentInformationActions.ClearSurchargeErrorAction,
    BtPayPaymentInformationActions.GetSurchargeAmountAction,
    (state) => {
      return {
        ...state,
        surchargeError: null,
      };
    },
  ),
  on(
    PoiSelectPaymentMethodComponentActions.paymentAccountSelected,
    PoiSelectPaymentMethodPaymentAccountActions.createPaymentAccountSuccess,
    PoaSelectPaymentMethodComponentActions.paymentAccountSelected,
    PoaSelectPaymentMethodPaymentAccountActions.createPaymentAccountSuccess,
    HostedPaymentsSelectPaymentMethodActions.paymentAccountSelected,
    HostedPaymentsSelectPaymentMethodPaymentAccountsActions.paymentAccountCreated,
    (state) => {
      return {
        ...state,
        surchargeAuthVerbiage: null,
      };
    },
  ),
  on(
    PayActions.RetrieveSurchargeAuthorizationVerbiageCompleteAction,
    PoiBtPaySelectPaymentMethodActions.surchargeAuthVerbiageRetrieved,
    HostedPaymentsSelectPaymentMethodAuthorizationVerbiageActions.surchargeAuthorizationVerbiageRetrieved,
    (state, action) => {
      return {
        ...state,
        surchargeAuthVerbiage: action.payload,
      };
    },
  ),
  on(
    PayActions.PaymentCompletedAction,
    PoiIntlStripeResultPaymentComponentActions.paymentCompleted,
    (state, action) => {
      return {
        ...state,
        paymentCompletedResponse: action.payload,
      };
    },
  ),
  on(PayActions.GetCutoffTimeForAchSuccessAction, (state, action) => {
    return {
      ...state,
      paymentCutoffTime: action.paymentCutoffTime,
    };
  }),
  on(PayActions.GetCutoffTimeForAchErrorAction, (state) => {
    return {
      ...state,
      paymentCutoffTime: null,
    };
  }),
  on(PayActions.InitializePayStore, () => {
    return {
      ...initialState,
    };
  }),
  on(BtPayPaymentInformationActions.UpdatePaymentReferenceAction, (state) => {
    if (state.paymentPreview == null) {
      return state;
    }

    return {
      ...state,
      paymentPreview: {
        ...state.paymentPreview,
        payments: state.paymentPreview?.payments.map((p) => {
          return {
            ...p,
            payment: {
              ...p.payment,
              transactionReference: null,
            },
            paymentReference: null,
          };
        }),
      },
      transactionAuthorizationResults: {},
    };
  }),
  on(PayActions.SetPaymentAccountAction, (state, action) => {
    return {
      ...state,
      selectedPaymentAccount: action.paymentAccount,
    };
  }),
  on(PayActions.SetPaymentDateAction, (state, action) => {
    return {
      ...state,
      paymentDate: action.paymentDate,
    };
  }),
  on(PayActions.SetEmailRecipientsAction, (state, action) => {
    return {
      ...state,
      emailRecipients: action.emailRecipients,
    };
  }),
  on(
    BtPayPaymentInformationActions.UpdatePaymentPreviewCompleteAction,
    PoiIntlMakePaymentPaymentInformationApiActions.paymentPreviewUpdated,
    PoiStripeResultIntlPaymentPreviewActions.loadPaymentPreviewSuccess,
    (state, action) => {
      return {
        ...state,
        paymentPreview: action.payload,
      };
    },
  ),
  on(
    BtPayPaymentInformationActions.CreatePaymentPreviewCompleteAction,
    (state, action) => {
      return {
        ...state,
        paymentPreview: action.payload,
        isAllPayablesPaidInFull: false,
      };
    },
  ),
  on(
    BtPayPaymentInformationActions.CreatePaymentPreviewAllPayablesPaidInFullAction,
    (state, action) => {
      return {
        ...state,
        paymentPreview: action.payload.error as PaymentPreviewV1Response,
        isAllPayablesPaidInFull: true,
      };
    },
  ),
  on(
    BtPayPaymentInformationActions.SubmitPaymentPreviewCompleteAction,
    PoiIntSelectPaymentTypeSessionActions.submitPaymentPreviewComplete,
    (state, action) => {
      return {
        ...state,
        paymentPreview: action.payload,
      };
    },
  ),
  on(
    BtPayPaymentInformationActions.UpdatePayOtherAmountCompleteAction,
    (state, action) => {
      return {
        ...state,
        payOtherAmount: action.payload,
      };
    },
  ),
  on(
    BtPayPaymentInformationActions.UpdatePayOtherAmountErrorAction,
    (state, action) => {
      return {
        ...state,
        payOtherAmount: {
          ...(state.payOtherAmount || {}),
          correlationId: action.payload.error.correlationId,
          errors: [
            ...(state.payOtherAmount?.errors || []).concat(
              action?.payload?.error?.errors.map(
                (e) =>
                  <PaymentInformationServiceErrorV1Response>{
                    code: e.code,
                    message: e.message,
                  },
              ),
            ),
          ],
        },
      };
    },
  ),
  on(PayActions.AuthorizePaymentAction, (state, action) => {
    const results = {
      ...state.transactionAuthorizationResults,
    };
    results[action.payload.transactionReference] = {};
    return {
      ...state,
      transactionAuthorizationResults: results,
    };
  }),
  on(PayActions.AuthorizePaymentCompleteAction, (state, action) => {
    const results = {
      ...state.transactionAuthorizationResults,
    };

    results[action.transactionReference] =
      action.transactionAuthorizationResult;

    return {
      ...state,
      transactionAuthorizationResults: results,
    };
  }),
  on(PayActions.AuthorizePaymentErrorAction, (state, action) => {
    const results = {
      ...state.transactionAuthorizationResults,
    };

    results[action.transactionReference] = action.payload;

    return {
      ...state,
      transactionAuthorizationResults: results,
    };
  }),
  on(
    PayActions.CheckPaymentStatusCompleteAction,
    PoiBtPayReviewPaymentActions.checkPaymentStatusCompleted,
    PoaBtPayReviewPaymentActions.checkPaymentStatusCompleted,
    HostedPaymentsReviewPaymentComponentPaymentActions.checkPaymentStatusCompleted,
    (state, action) => {
      const newState = {
        ...state,
        paymentStatusCheckCount: action.checkStatusCount,
        paymentAuthorizing: action.authorizationPending,
        paymentAuthorizationPending: action.authorizationPending,
      };

      // Even if we have updated results, we don't want to overwrite them if the user has already decided to proceed to the summary screen with a pending payment
      if (!state.paymentStatusCheckTimedOut) {
        newState.transactionAuthorizationResults = action.results;
      }

      newState.paymentStatusCheckTimedOut = action.checkStatusTimeout;

      return newState;
    },
  ),
  on(
    PayActions.CheckPaymentStatusCancelledAction,
    PoiBtPayReviewPaymentActions.checkPaymentStatusTimedOutAction,
    PoaBtPayReviewPaymentActions.checkPaymentStatusTimedOutAction,
    HostedPaymentsReviewPaymentComponentPaymentActions.checkPaymentStatusTimedOut,
    (state, action) => {
      return {
        ...state,
        transactionAuthorizationResults: action.results,
      };
    },
  ),
  on(
    PoiBtPayReviewPaymentActions.checkPaymentStatusCanceledAction,
    PoiBtPayReviewPaymentActions.checkPaymentStatusErrorAction,
    PoaBtPayReviewPaymentActions.checkPaymentStatusCanceledAction,
    PoaBtPayReviewPaymentActions.checkPaymentStatusErrorAction,
    HostedPaymentsReviewPaymentComponentActions.paymentStatusCheckCanceled,
    HostedPaymentsReviewPaymentComponentPaymentActions.checkPaymentStatusError,
    (state) => {
      return {
        ...state,
        paymentStatusCheckTimedOut: true,
        paymentAuthorizationPending: false,
      };
    },
  ),
  on(PayActions.CheckPaymentStatusErrorAction, (state) => {
    return {
      ...state,
      paymentAuthorizing: false,
      paymentAuthorizationPending: true,
      paymentStatusCheckTimedOut: true,
    };
  }),
  on(
    BtPayPaymentAccountsActions.LoadAvailablePaymentAccountsSuccess,
    BtPayPaymentAccountsActions.LoadAvailablePaymentAccountsAfterRedirectSuccess,
    PoaPaymentReceiptComponentActions.paymentAccountsLoaded,
    (state, action) => {
      return {
        ...state,
        paymentAccounts: action?.paymentAccounts?.map((paymentAccount) => {
          return {
            ...paymentAccount,
            displayName: getAccountDisplayName(paymentAccount),
          };
        }),
      };
    },
  ),
  on(
    BtPayPaymentAccountsActions.LoadAvailablePaymentAccountsAfterRedirectSuccess,
    (state, action) => {
      const selectedPaymentAccount = action.paymentAccounts.find(
        (account) =>
          account.paymentAccountIdentifierBurn ===
          state.redirectSelectedPaymentAccountBurn,
      );
      return {
        ...state,
        selectedPaymentAccount: {
          burn: selectedPaymentAccount.paymentAccountIdentifierBurn,
          displayName: getAccountDisplayName(selectedPaymentAccount),
          nameOnAccount: selectedPaymentAccount.nameOnBankAccount,
          paymentMethod: selectedPaymentAccount.paymentMethod,
        },
      };
    },
  ),
  on(
    PoiSelectPaymentMethodPaymentAccountActions.createPaymentAccountSuccess,
    PoaSelectPaymentMethodPaymentAccountActions.createPaymentAccountSuccess,
    HostedPaymentsSelectPaymentMethodPaymentAccountsActions.paymentAccountCreated,
    (state, action) => {
      const savedPaymentAccounts = state?.paymentAccounts?.slice() || [];
      savedPaymentAccounts.push(action.payload);
      return {
        ...state,
        paymentAccounts: savedPaymentAccounts,
      };
    },
  ),
  on(
    PoiBtPaySelectPaymentMethodActions.paymentAccountDeleted,
    PoaBtPaySelectPaymentMethodActions.paymentAccountDeleted,
    PoaSelectPaymentMethodPaymentAccountActions.deletePaymentAccountSuccess,
    (state, action) => {
      const savedPaymentAccounts = state.paymentAccounts.filter(
        (a) => a.paymentAccountIdentifierBurn != action.paymentAccountBurn,
      );
      return {
        ...state,
        paymentAccounts: savedPaymentAccounts,
      };
    },
  ),
  on(
    PoiBtPaySelectPaymentMethodActions.selectedPaymentAccountDeleted,
    PoaSelectPaymentMethodComponentActions.selectedPaymentAccountDeleted,
    (state) => {
      return {
        ...state,
        achPaymentDateWarningVerbiage: null,
        bankAuthVerbiage: null,
        surchargeAuthVerbiage: null,
        showAchPaymentDateWarning: false,
      };
    },
  ),
  on(
    BtPayPaymentInformationActions.ExecuteSingleTransactionPaymentPreviewAction,
    (state) => {
      const results = {
        ...state.transactionAuthorizationResults,
      };
      results[
        BurnToken.parse(
          state.paymentPreview.payments[0].payment.transactionReference.burn,
        ).propertyValue
      ] = {};
      return {
        ...state,
        transactionAuthorizationResults: results,
      };
    },
  ),
  on(
    BtPayPaymentInformationActions.ExecutePaymentPreviewSuccessAction,
    (state, action) => {
      const results = {
        ...state.transactionAuthorizationResults,
      };
      results[action.transactionReference] = action.result;

      return {
        ...state,
        transactionAuthorizationResults: results,
      };
    },
  ),
  on(
    BtPayPaymentInformationActions.ExecutePaymentPreviewSuccessAction,
    BtPayPaymentInformationActions.ExecutePaymentPreviewBadRequestErrorAction,

    SessionActions.UpdatePaymentErrorAction,
    (state) => {
      return {
        ...state,
        paymentAuthorizing: false,
      };
    },
  ),
  on(
    BtPayPaymentInformationActions.ExecutePaymentPreviewServerErrorAction,
    (state) => {
      return {
        ...state,
        paymentStatusCheckCount: 0,
        paymentAuthorizationPending: true,
        paymentStatusCheckTimedOut: false,
      };
    },
  ),
  on(SessionActions.UpdatePaymentAction, (state) => {
    return {
      ...state,
      paymentAuthorizing: true,
    };
  }),
  on(PayActions.GetAutopayStatusAction, (state) => {
    return {
      ...state,
      isAutopayEnabled: null,
    };
  }),
  on(PayActions.GetAutopayStatusSuccessAction, (state, action) => {
    const selectedPaymentAccountId = +BurnToken.parse(
      state.selectedPaymentAccount.burn,
    ).propertyValue;
    const isAutopayEnabled =
      action.autopayStatusResponse.paymentAccountBurn.paymentAccountId ===
      selectedPaymentAccountId;

    return {
      ...state,
      isAutopayEnabled,
    };
  }),
  on(PayActions.GetAutopayStatusErrorAction, (state) => {
    return {
      ...state,
      isAutopayEnabled: false,
    };
  }),
  on(
    BtPayPaymentInformationActions.GetBuyerAccountsSuccessAction,
    PoaPadResultComponentPayInfoActions.getBuyerAccountsSuccess,
    (state, action) => {
      return {
        ...state,
        buyerAccounts: action.buyerAccounts,
      };
    },
  ),
  on(PayActions.ValidatePaymentDateCompleteAction, (state, action) => {
    return {
      ...state,
      showAchPaymentDateWarning:
        action.paymentDateValidationResult.showAchPaymentDateWarning,
      achPaymentDateWarningVerbiage:
        action.paymentDateValidationResult.achPaymentDateWarningVerbiage,
    };
  }),
  on(PayActions.CheckAutopayEligibilitySuccessAction, (state, action) => {
    return {
      ...state,
      unenrolledAutopayAccounts: action.unenrolledAccounts,
    };
  }),
  on(PayActions.CheckAutopayEligibilityErrorAction, (state) => {
    return {
      ...state,
      unenrolledAutopayAccounts: [],
    };
  }),
  on(
    PoiReviewPaymentComponentActions.reviewPaymentStepSubmitted,
    PoaReviewPaymentComponentActions.reviewPaymentStepSubmitted,
    HostedPaymentsReviewPaymentComponentActions.reviewPaymentStepSubmitted,
    (state, action) => {
      if (!action.event.valid) {
        return state;
      }

      return {
        ...state,
        paymentAuthorizationChannel: action.event.value.achAuthMethod,
        captchaToken: action.event.value.recaptcha ?? null,
        transactionAuthorizationResults: {},
        paymentAuthorizing: true,
        paymentStatusCheckCount: 0,
        paymentStatusCheckTimedOut: false,
      };
    },
  ),
  on(
    PoiBtPayReviewPaymentActions.paymentExecuted,
    PoaBtPayReviewPaymentActions.paymentExecuted,
    HostedPaymentsReviewPaymentComponentPaymentActions.executePaymentComplete,
    (state, action) => {
      const paymentPending = Object.values(action.transactionResults).every(
        (t) => t.gpalStatus === PaymentStatus.TIMEOUT,
      );

      return {
        ...state,
        paymentAuthorizing: paymentPending,
        paymentAuthorizationPending: paymentPending,
        transactionAuthorizationResults: action.transactionResults,
      };
    },
  ),
  on(
    PoiBtPaySelectPaymentMethodActions.paymentAccountExpirationDateUpdated,
    PoaBtPaySelectPaymentMethodActions.paymentAccountExpirationDateUpdated,
    (state, action) => {
      return {
        ...state,
        paymentAccounts: state.paymentAccounts.map((paymentAccount) =>
          paymentAccount.paymentAccountIdentifierBurn ===
          action.paymentAccountIdentifierBurn
            ? {
                ...paymentAccount,
                expirationMonth: action.expirationDate.expirationMonth,
                expirationYear: action.expirationDate.expirationYear,
              }
            : paymentAccount,
        ),
      };
    },
  ),
  on(
    PoiBtPayReviewPaymentActions.sensitiveInformationCleared,
    PoaBtPaySelectPaymentMethodActions.sensitiveInformationCleared,
    (state) => {
      return {
        ...state,
        paymentAccounts:
          state.paymentAccounts?.map((paymentAccount) => {
            return {
              ...paymentAccount,
              paymentMethodFormDetails: null,
            };
          }) ?? [],
      };
    },
  ),
  on(
    HostedPaymentsReviewPaymentComponentPaymentActions.executePaymentComplete,
    (state, action) => {
      if (!action.paymentComplete) {
        return state;
      }

      return {
        ...state,
        paymentAccounts: state.paymentAccounts.map((paymentAccount) => {
          return {
            ...paymentAccount,
            paymentMethodFormDetails: null,
          };
        }),
      };
    },
  ),
  on(
    PoiIntlSepaResultPaymentComponentActions.updateTransactionAuthorizationResults,
    PoiIntlStripeResultPaymentComponentActions.updateTransactionAuthorizationResults,
    PoiPaymentReceiptComponentActions.updateTransactionAuthorizationResults,
    PoaPaymentReceiptComponentActions.updateTransactionAuthorizationResults,
    PoiIntlPaymentReceiptComponentActions.updateTransactionAuthorizationResults,
    (state, action) => {
      const results = {
        ...(state.transactionAuthorizationResults || {}),
      };

      if (Object.keys(results).length === 0) {
        results[action.transactionReference] =
          action.transactionAuthorizationResult[0];
      }

      return {
        ...state,
        transactionAuthorizationResults: results,
      };
    },
  ),
  on(
    PoiSelectPaymentMethodPadAgreementActions.padVerificationSuccess,
    PoaSelectPaymentMethodPadAgreementActions.padVerificationSuccess,
    PoaPadResultComponentPadActions.padVerificationSuccess,
    HostedPaymentsPadResultComponentPadActions.padVerificationSuccess,
    PoiPadResultComponentPadActions.padVerificationSuccess,
    (state, action) => {
      return {
        ...state,
        paymentAccounts: setPadVerifiedStatusOnBankAccounts(
          state.paymentAccounts,
          action.payload,
        ),
      };
    },
  ),
  on(
    PoiSelectPaymentMethodComponentActions.submittedAddPadAgreementForm,
    PoaSelectPaymentMethodComponentActions.submittedAddPadAgreementForm,
    HostedPaymentsSelectPaymentMethodActions.submittedAddPadAgreementForm,
    PoiSelectPaymentMethodComponentActions.submittedAddPadFormForSelectedBankAccount,
    PoaSelectPaymentMethodComponentActions.submittedAddPadFormForSelectedBankAccount,
    HostedPaymentsSelectPaymentMethodActions.submittedAddPadFormForSelectedBankAccount,
    (state, { payload }) => ({
      ...state,
      padAgreementFormSubmitEvent: payload,
    }),
  ),
  on(
    PoiSelectPaymentMethodPadAgreementActions.updatePadVerifiedStatusSuccess,
    HostedPaymentsSelectPaymentMethodPadAgreementActions.updatePadVerifiedStatusSuccess,
    PoaSelectPaymentMethodPadAgreementActions.updatePadVerifiedStatusSuccess,
    (state, action) => ({
      ...state,
      paymentAccounts: updatePadVerifiedStatus(
        state.paymentAccounts,
        action.payload,
      ),
    }),
  ),
  /*
  Here we update the selected payment account as we might have made updates to the padSignedSeparately field
  and we want this value to match the value stored in the flow-specific stores.

  We also set padAgreementFormSubmitEvent to null because, when the call(s) to prepare/redirect to Twikey fail,
  we don't want the user to randomly get redirected if/when the calls start working. As long as padAgreementFormSubmitEvent is not null,
  our effects are written in such a way that the chain of events needed to redirect to Twikey will get kicked off.

  We want the user to be able to select the same bank account and/or other bank accounts with no redirects
  until they click Proceed to Review and answer the prompts with success.
  */
  on(
    PoiSelectPaymentMethodComponentActions.paymentAccountSelected,
    PoaSelectPaymentMethodComponentActions.paymentAccountSelected,
    HostedPaymentsSelectPaymentMethodActions.paymentAccountSelected,
    (state, { payload }) => ({
      ...state,
      padAgreementFormSubmitEvent: null,
      paymentAccounts: state.paymentAccounts?.map((account) =>
        account.paymentAccountIdentifierBurn ===
        payload.paymentAccountIdentifierBurn
          ? payload
          : account,
      ),
    }),
  ),
  on(
    PoiPadResultComponentSessionActions.loadSessionRedirectStateSuccess,
    PoaPadResultComponentSessionActions.loadSessionRedirectStateSuccess,
    HostedPaymentsPadResultComponentSessionActions.loadSessionRedirectStateSuccess,
    PoiStripeResultIntlSessionActions.loadSessionRedirectStateSuccess,
    (state, { payload }) => ({
      ...state,
      payOtherAmount: payload.redirectState.payOtherAmount,
      redirectOtpPaymentAccounts: payload.redirectState.oneTimePaymentAccounts,
      redirectSelectedPaymentAccountBurn:
        payload.redirectState.selectedPaymentAccountBurn,
      paymentPreview: payload.redirectState.paymentDetails.paymentPreview,
    }),
  ),
  on(
    PoiPadResultComponentPadActions.completeTwikeyInviteSuccess,
    PoaPadResultComponentPadActions.completeTwikeyInviteSuccess,
    HostedPaymentsPadResultComponentPadActions.completeTwikeyInviteSuccess,
    (state) => {
      const paymentAccount = state.paymentAccounts.find(
        (account) =>
          account.paymentAccountIdentifierBurn ===
          state.selectedPaymentAccount.burn,
      );

      state.paymentAccounts.splice(
        state.paymentAccounts.indexOf(paymentAccount),
        1,
        {
          ...paymentAccount,
          padVerifiedStatus: {
            padSignedSeparately: false,
            padVerified: true,
          },
        },
      );

      return {
        ...state,
        paymentAccounts: [...state.paymentAccounts],
      };
    },
  ),
  on(
    PoiPadResultComponentActions.initialized,
    HostedPaymentsPadResultComponentActions.initialized,
    PoaPadResultComponentActions.initialized,
    (state, action) => ({
      ...state,
      twikeyExitStatus: action.payload as TwikeyExitStatus,
    }),
  ),
  on(
    PoiSelectPaymentMethodComponentActions.canceledAddPadAgreementForm,
    HostedPaymentsSelectPaymentMethodActions.canceledAddPadAgreementForm,
    PoaSelectPaymentMethodComponentActions.canceledAddPadAgreementForm,
    (state) => ({
      ...state,
      twikeyExitStatus: null,
    }),
  ),
  /* istanbul ignore next */
  on(PoiStripeResultIntlComponentActions.initialized, (state, action) => ({
    ...state,
    stripeResultStatus: action.status,
  })),
  on(
    CheckoutResolversActions.platformCheckoutResolved,
    CheckoutResolversActions.paymentLinksCheckoutResolved,
    (state, action) => ({
      ...state,
      disablePaymentDate: action.disablePaymentDate,
    }),
  ),
  on(
    MakePaymentPaymentLinksApiActions.platformJwtObtained,
    PoaPaymentDetailsPaymentLinksApiActions.platformJwtObtained,
    PoiIntlMakePaymentPaymentLinksApiActions.platformJwtObtained,
    (state) => ({
      ...state,
      disablePaymentDate: false,
    }),
  ),
  on(
    PoiMakePaymentComponentActions.signInBannerDismissed,
    PoiIntlMakePaymentComponentActions.signInBannerDismissed,
    PoaPaymentDetailsComponentActions.signInBannerDismissed,
    (state) => ({
      ...state,
      signInBannerDismissed: true,
      issuePlatformJwtError: false,
    }),
  ),
  on(CheckoutHeaderComponentActions.signInClicked, (state) => ({
    ...state,
    signInBannerDismissed: false,
    signInEmailSentBannerVisible: false,
    issuePlatformJwtError: false,
    signInEmailErrorOccurred: false,
  })),
  on(
    MakePaymentPaymentLinksApiActions.platformJwtObtained,
    PoaPaymentDetailsPaymentLinksApiActions.platformJwtObtained,
    PoiIntlMakePaymentPaymentLinksApiActions.platformJwtObtained,
    PoiMakePaymentComponentActions.continueAsGuestClicked,
    PoiIntlMakePaymentComponentActions.continueAsGuestClicked,
    PoaPaymentDetailsComponentActions.continueAsGuestClicked,
    (state) => ({
      ...state,
      signInBannerDismissed: true,
      signInEmailSentBannerVisible: false,
      issuePlatformJwtError: false,
      signInEmailErrorOccurred: false,
    }),
  ),
  /* istanbul ignore next */
  on(
    MakePaymentPaymentLinksApiActions.signInEmailSent,
    PoaPaymentDetailsPaymentLinksApiActions.signInEmailSent,
    PoiIntlMakePaymentPaymentLinksApiActions.signInEmailSent,
    (state, action) => ({
      ...state,
      signInEmailToken: action.token,
      signInEmailSentBannerVisible: true,
      signInEmailErrorOccurred: false,
    }),
  ),
  /* istanbul ignore next */
  on(
    MakePaymentPaymentLinksApiActions.signInEmailError,
    PoaPaymentDetailsPaymentLinksApiActions.signInEmailError,
    PoiIntlMakePaymentPaymentLinksApiActions.signInEmailError,
    (state, action) => ({
      ...state,
      signInEmailSentBannerVisible: true,
      signInEmailErrorOccurred: true,
      signInAttemptsExceeded:
        state.signInAttemptsExceeded ||
        isSignInAttemptsExceededError(action.error),
    }),
  ),
  // The platform JWT issuance step failed (any 4xx/5xx). Surface a generic
  // error on the sign-in banner and revert from the "email sent" banner back
  // to the sign-in banner so the buyer can retry or continue as guest.
  on(
    MakePaymentPaymentLinksApiActions.platformJwtError,
    PoaPaymentDetailsPaymentLinksApiActions.platformJwtError,
    PoiIntlMakePaymentPaymentLinksApiActions.platformJwtError,
    (state) => ({
      ...state,
      issuePlatformJwtError: true,
      signInEmailSentBannerVisible: false,
    }),
  ),
  on(
    PoiMakePaymentComponentActions.signInBannerSignedIn,
    PoiIntlMakePaymentComponentActions.signInBannerSignedIn,
    PoaPaymentDetailsComponentActions.signInBannerSignedIn,
    (state, action) => ({
      ...state,
      signInUsername: action.username,
      issuePlatformJwtError: false,
    }),
  ),
  on(
    PoiMakePaymentComponentActions.signInChangeUsername,
    PoiIntlMakePaymentComponentActions.signInChangeUsername,
    PoaPaymentDetailsComponentActions.signInChangeUsername,
    (state) => ({
      ...state,
      signInEmailToken: null,
      signInEmailSentBannerVisible: false,
      issuePlatformJwtError: false,
      signInEmailErrorOccurred: false,
    }),
  ),
);

export const PayStore = createFeatureSelector<PaymentStoreState>('btpay');

export const authorizePaymentMap = (
  state: PaymentStoreState,
): PaymentExecutionV1Response => state.authorizePayment;

export const paymentStatusMap = (
  state: PaymentStoreState,
): InvoiceSavedPaymentAccountResponse => state.paymentStatus;

export const paymentOverrideMap = (state: PaymentStoreState): string[] =>
  state.cardOverrideData;

export const authVerbiageMap = (
  state: PaymentStoreState,
): RetrieveAuthorizationVerbiageResponseV1 => state.bankAuthVerbiage;

export const surchargeErrorMap = (
  state: PaymentStoreState,
): PaymentPreviewErrorPayload => state.surchargeError;

export const surchargeAuthVerbiageMap = (
  state: PaymentStoreState,
): RetrieveAuthorizationVerbiageResponseV1 => state.surchargeAuthVerbiage;

export const bankAuthVerbiageMap = (
  state: PaymentStoreState,
): RetrieveAuthorizationVerbiageResponseV1 => state.bankAuthVerbiage;

export const paymentCompletedResponseMap = (
  state: PaymentStoreState,
): PaymentCompletedResponse => state.paymentCompletedResponse;

export const paymentPreviewMap = (
  state: PaymentStoreState,
): PaymentPreviewV1Response => state.paymentPreview;

export const AuthorizePaymentStore = createSelector(
  PayStore,
  authorizePaymentMap,
);

export const PaymentStatusStore = createSelector(PayStore, paymentStatusMap);

export const PaymentOverrideStore = createSelector(
  PayStore,
  paymentOverrideMap,
);

export const AuthVerbiageStore = createSelector(PayStore, authVerbiageMap);

export const SurchargeErrorStore = createSelector(PayStore, surchargeErrorMap);

export const SurchargeAuthVerbiageStore = createSelector(
  PayStore,
  surchargeAuthVerbiageMap,
);

export const BankAuthVerbiageStore = createSelector(
  PayStore,
  bankAuthVerbiageMap,
);

export const BankHolidayStore = createSelector(PayStore, (s) => s.bankHolidays);

export const CutOffTimeStore = createSelector(
  PayStore,
  (s) => s.paymentCutoffTime,
);

export const PaymentCompletedResponseStore = createSelector(
  PayStore,
  paymentCompletedResponseMap,
);

export const SelectPayOtherAmountStore = createSelector(
  PayStore,
  (state) => state.payOtherAmount,
);

export const PaymentPreviewStore = createSelector(PayStore, paymentPreviewMap);

export const selectPaymentAuthorizationChannel = createSelector(
  PayStore,
  (state) => state.paymentAuthorizationChannel,
);

export const selectCaptchaToken = createSelector(
  PayStore,
  (state) => state.captchaToken,
);

export const selectPadAgreementFormSubmitEvent = createSelector(
  PayStore,
  (state) => state.padAgreementFormSubmitEvent,
);

export const selectRedirectOtpPaymentAccounts = createSelector(
  PayStore,
  (state) => state.redirectOtpPaymentAccounts,
);

export const selectRedirectSelectedPaymentAccountBurn = createSelector(
  PayStore,
  (state) => state.redirectSelectedPaymentAccountBurn,
);

export const selectTwikeyExitStatus = createSelector(
  PayStore,
  (state) => state.twikeyExitStatus,
);

/* istanbul ignore next */
export const selectStripeResultStatus = createSelector(
  PayStore,
  (state) => state.stripeResultStatus,
);
